import React, { useEffect, useState } from "react";
import "./Confirm_Delivery_Address_Offcanvas.css";
import { Offcanvas } from "react-bootstrap";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import Gray_Btn from "../common_btn/gray_btn/Gray_Btn";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import Blue_Btn from "../common_btn/blue_btn/Blue_Btn";
import { getAddress } from "../../../utils/apis/orderProcess/orderProcess";

const Confirm_Delivery_Address_Offcanvas = ({ show, onHide }) => {
  const [address, setAddress] = useState([]);
  // console.log(address,"addressaddressaddressaddress");

  const getAddressFunc = async () => {
    const res = await getAddress();
    console.log(res, "resresresres");
    if (res?.success) {
      await setAddress(res?.data);
    }
  };

  useEffect(() => {
    getAddressFunc();
  }, []);

  const navigate = useNavigate();

  return (
    <Offcanvas
      className="right_bottom_offcanvas confirm_delivery_address_offcanvas"
      placement="bottom"
      show={show}
      onHide={onHide}
    >
      <Offcanvas.Body>
        <div className="Confirm_Addess_Modal">
          <div className="modal-content">
            <div className="modal-header">
              <div className="title_text">
                <p>Confirm Delivery Address</p>
              </div>

              <div className="right_side">
                <img
                  src="/assets/Image/header/close.png"
                  className="close_img"
                  onClick={onHide}
                />
              </div>
            </div>

            <div className="modal-body">
              <div className="address_holder">
                <p className="type_text">
                  {" "}
                  <FontAwesomeIcon
                    icon={faBuilding}
                    className="inner_icon"
                  />{" "}
                  {address?.[0]?.address_type}
                </p>

                <p className="address_text">
                  {`${address?.[0]?.flat_home_bldg},${address?.[0]?.col_land_strt},${address?.[0]?.state?.name},${address?.[0]?.city?.name},${address?.[0]?.pincode?.name}`}
                </p>

                <div className="btns_holder">
                  <Blue_Btn
                    btn_name="Update Address"
                    onClick={() => {
                      navigate("/saved-address");
                    }}
                  />
                  <Green_Btn
                    btn_name="Proceed"
                    onClick={() => {
                      navigate("/checkout");
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Confirm_Delivery_Address_Offcanvas;
